module.exports = __webpack_public_path__ + "img/1590016588.68bf662c.jpg";